import { useContext, createContext } from "react";
import { baseURL } from "../lib";
import { useAuth } from "./AuthContext";
import axios from 'axios'

const PrinterContext = createContext()

const PrinterProvider = ({ children }) => {
    const { headers, toast, restaurantId } = useAuth();

    const getAllPrinters = async (currentPage, rowsPerPage, sortField, sortOrder, filter) => {
        try {
            const { data } = await axios.get(`${baseURL}/printer/list?&sortField=${sortField}&sortOrder=${sortOrder}&page=${currentPage}&limit=${rowsPerPage}&restaurant_id=${restaurantId}&filter=${filter !== '' ? filter : null}`, { headers })
            if (data.error === false) {
                return data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Printer', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    const getSinglePrinter = async (id) => {
        try {
            let response = await axios.get(`${baseURL}/printer/single-printer/${id}`, { headers })
            if (response.data.error === false) {
                return response.data
            } else {
                toast.current?.show({ severity: 'error', summary: 'Printer', detail: response?.data?.message, life: 3000 })
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Printer', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    const createPrinter = async (printerDetail) => {
        try {
            const { data } = await axios.post(`${baseURL}/printer/create`, printerDetail, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast.current?.show({ severity: 'success', summary: 'Printer', detail: data.message, life: 3000 })
                }, 500);
                return data;
            } else {
                toast.current?.show({ severity: 'error', summary: 'Printer', detail: data.message, life: 3000 })
            }
        } catch (error) {
            if (error.response) {
                const errors = error.response.data.errors;
                if (errors && Array.isArray(errors) && errors.length > 0) {
                    if (errors.length > 1) {
                        toast.current?.show({ severity: 'error', summary: 'Printer', detail: "Please fill all mandatory fields.", life: 3000 })
                    } else {
                        toast.current?.show({ severity: 'error', summary: 'Printer', detail: errors[0].msg, life: 3000 })
                    }
                }
            } else {
                toast.current?.show({ severity: 'error', summary: 'Printer', detail: 'An error occurred. Please try again later.', life: 3000 })
            }
        }
    }

    const updatePrinter = async (id, printerDetail) => {
        try {
            const { data } = await axios.put(`${baseURL}/printer/update/${id}`, printerDetail, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast.current?.show({ severity: 'success', summary: 'Printer', detail: data.message, life: 3000 })
                }, 500);
                return data;
            } else {
                toast.current?.show({ severity: 'error', summary: 'Printer', detail: data.message, life: 3000 })
            }
        } catch (error) {
            if (error.response) {
                const errors = error.response.data.errors;
                if (errors && Array.isArray(errors) && errors.length > 0) {
                    if (errors.length > 1) {
                        toast.current?.show({ severity: 'error', summary: 'Printer', detail: "Please fill all mandatory fields.", life: 3000 })
                    } else {
                        toast.current?.show({ severity: 'error', summary: 'Printer', detail: errors[0].msg, life: 3000 })
                    }
                }
            } else {
                toast.current?.show({ severity: 'error', summary: 'Printer', detail: 'An error occurred. Please try again later.', life: 3000 })
            }
        }
    }

    const deletePrinter = async (id) => {
        try {
            const { data } = await axios.put(`${baseURL}/printer/delete/${id}`, {}, { headers });
            if (data.error === false) {
                toast.current.show({ severity: 'success', summary: 'Printer', detail: data.message, life: 3000 })
            } else {
                toast.current?.show({ severity: 'error', summary: 'Printer', detail: data.message, life: 3000 })
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Printer', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    return (
        <PrinterContext.Provider value={{ getAllPrinters, getSinglePrinter, createPrinter, updatePrinter, deletePrinter }}>
            {children}
        </PrinterContext.Provider>
    )
}

const usePrinter = () => useContext(PrinterContext)

export { usePrinter, PrinterProvider }